import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { User, PaginatedResult, MyTenant } from '@niko-crm/ui';

export const UserActions = createActionGroup({
  source: 'Users',
  events: {
    'Load Users': props<{ page: number; limit: number; search?: string }>(),
    'Load Users Success': props<{ result: PaginatedResult<User> }>(),
    'Load Users Failure': props<{ error: string }>(),
    'Create User': props<{ payload: Partial<User> }>(),
    'Create User Success': props<{ user: User }>(),
    'Create User Failure': props<{ error: string }>(),
    'Update User': props<{ id: string; payload: Partial<User> }>(),
    'Update User Success': props<{ user: User }>(),
    'Update User Failure': props<{ error: string }>(),
    // Soft delete (BR-USER-09): the row stays in the list with `active: false`,
    // so success carries the updated user rather than just the id — removing
    // the row would hide the very entry the reactivate action needs.
    'Delete User': props<{ id: string }>(),
    'Delete User Success': props<{ user: User }>(),
    'Delete User Failure': props<{ error: string }>(),
    'Reactivate User': props<{ id: string }>(),
    'Reactivate User Success': props<{ user: User }>(),
    'Reactivate User Failure': props<{ error: string }>(),
    'Resend Invitation': props<{ id: string }>(),
    'Resend Invitation Success': props<{ user: User }>(),
    'Resend Invitation Failure': props<{ error: string }>(),
    'Reset User Password': props<{ id: string }>(),
    'Reset User Password Success': props<{ user: User; temporaryPassword: string }>(),
    'Reset User Password Failure': props<{ error: string }>(),
    // Pre-selection tenant picker (BR-AUTH-01) — normal user with N>1
    // memberships, fed from GET /users/me/tenants.
    'Load My Tenants': emptyProps(),
    'Load My Tenants Success': props<{ tenants: MyTenant[] }>(),
    'Load My Tenants Failure': props<{ error: string }>(),
  },
});
